import { InputRule } from '@tiptap/core';
import { BulletList, OrderedList, TaskItem, } from '@tiptap/extension-list';
const listsEnabled = (getEnableListsSetting) => {
    if (!getEnableListsSetting) {
        return false;
    }
    return getEnableListsSetting() === true;
};
const gateInputRule = (rule, getEnableListsSetting) => {
    const originalHandler = rule.handler.bind(rule);
    return new InputRule({
        find: rule.find,
        undoable: rule.undoable,
        handler: (props) => {
            if (!listsEnabled(getEnableListsSetting)) {
                return null;
            }
            return originalHandler(props);
        },
    });
};
const gateParentInputRules = (parentRules, getEnableListsSetting) => {
    return (parentRules ?? []).map((rule) => gateInputRule(rule, getEnableListsSetting));
};
export const GatedBulletList = BulletList.extend({
    addOptions() {
        return {
            ...this.parent?.(),
            getEnableListsSetting: undefined,
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-Shift-8': () => {
                if (!listsEnabled(this.options.getEnableListsSetting)) {
                    return false;
                }
                return this.editor.commands.toggleBulletList();
            },
        };
    },
    addInputRules() {
        return gateParentInputRules(this.parent?.(), this.options.getEnableListsSetting);
    },
});
export const GatedOrderedList = OrderedList.extend({
    addOptions() {
        return {
            ...this.parent?.(),
            getEnableListsSetting: undefined,
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-Shift-7': () => {
                if (!listsEnabled(this.options.getEnableListsSetting)) {
                    return false;
                }
                return this.editor.commands.toggleOrderedList();
            },
        };
    },
    addInputRules() {
        return gateParentInputRules(this.parent?.(), this.options.getEnableListsSetting);
    },
});
export const GatedTaskItem = TaskItem.extend({
    addOptions() {
        return {
            ...this.parent?.(),
            getEnableListsSetting: undefined,
        };
    },
    addInputRules() {
        return gateParentInputRules(this.parent?.(), this.options.getEnableListsSetting);
    },
});
//# sourceMappingURL=gated-list-input-rules.js.map